import React, { useMemo } from 'react';
import SuspenseComponent from '../views/components/SuspenseComponent';
import moment from 'moment';
import {MINUTES_BEFORE_EXPIRED_HEARTBEAT_OF_MACHINE} from './../../src/variables/constants.js'
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { getAllDevices } from "API";
import { useQuery } from 'react-query'

const getActualColumnCount = (prop) => {
  let n = 0;
  while (prop[`column${n + 1}_units`] != null) n++;
  return n;
};

const Dashboard = () => {
  const dataDevices = useQuery('Dashboard', () => getAllDevices(), {
    refetchInterval: 30000,
  });

  const maxColumns = useMemo(() => {
    const devices = dataDevices.data?.data ?? [];
    return devices.reduce((max, prop) => Math.max(max, getActualColumnCount(prop)), 0);
  }, [dataDevices.data]);

  const data = useMemo(
    () =>
      dataDevices.data?.data?.map((prop, key) => {
        const row = {
          id: key,
          dashboardName: prop.name,
          dashboardSerial: prop.serial,
          device_status: prop.status,
          daily_sales: prop.daily_sales,
          total_units: prop.total_units,
          total_empty_units: prop.total_empty_units,
          lowest_log_lvl: prop.lowest_log_lvl,
          heartbeat: moment.utc(prop.heartbeat).local().format("YYYY-MM-DD HH:mm:ss"),
          expired: moment().diff(moment.utc(prop.heartbeat), 'minutes') >= MINUTES_BEFORE_EXPIRED_HEARTBEAT_OF_MACHINE ? true : false,
          actions: (
            <div className="actions-right">
              <Button color="info"
                href={`/user/device/details/${prop.serial}`}
              >
                Go to
              </Button>
            </div>
          )
        };

        const n = getActualColumnCount(prop);
        for (let i = 1; i <= n; i++) {
          row[`column${i}_units`] = prop[`column${i}_units`];
          row[`column${i}_status`] = prop[`column${i}_status`];
        }

        return row;
      }) ?? [],
    [dataDevices.data]
  );

  const tableColumns = useMemo(() => [
    {
      Header: "Name",
      accessor: "dashboardName",
      isNamedPlaceholder: true,
    },
    // {
    //   Header: "Serial",
    //   accessor: "dashboardSerial",
    //   isNamedPlaceholder: true,
    // },
    {
      Header: "Status",
      accessor: "device_status",
      isNamedPlaceholder: true,
    },
    {
      Header: "Sales",
      accessor: "daily_sales",
      isNamedPlaceholder: true,
    },
    ...Array.from({ length: maxColumns }, (_, i) => ({
      Header: `C${i + 1}`,
      accessor: `column${i + 1}_units`,
      isNamedPlaceholder: true,
      Cell: ({ value }) => (value === undefined || value === null ? '—' : value),
    })),
    {
      Header: "Charged",
      accessor: "total_units",
      isNamedPlaceholder: true,
    },
    {
      Header: "Empties",
      accessor: "total_empty_units",
      isNamedPlaceholder: true,
    },
    {
      Header: "Heartbeat",
      accessor: "heartbeat",
      isNamedPlaceholder: true,
    },
    {
      Header: "Actions",
      accessor: "actions",
      sortable: false,
      filterable: false
    }
  ], [maxColumns]);

  return (
    <>
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Your devices</CardTitle>
              </CardHeader>
              <CardBody>
                {dataDevices.isLoading ? <SuspenseComponent /> :
                  dataDevices.isError ? <p className="text-center text-danger">Failed to load devices. Please refresh the page.</p> :
                  <div className='devices-table' style={{'--max-cols': maxColumns}}>
                    <ReactTable
                      data={data}
                      filterable
                      resizable={false}
                      columns={tableColumns}
                      defaultPheartbeatSize={10}
                      showPaginationTop
                      showPaginationBottom={false}
                      className="-striped -highlight"
                    />
                  </div>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
